var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.classesModalState
    ? _c(
        "q-modal",
        {
          staticClass: "sl-modal",
          class: { loading: _vm.loading },
          attrs: {
            id: "classDetailsModal",
            value: _vm.classesModalState,
            "no-esc-dismiss": true,
            "no-backdrop-dismiss": true,
            "content-css": {
              width: _vm.selectedTab === "students" ? "99vw" : "1400px",
              maxWidth: "100%",
              minHeight: "75vh"
            },
            maximized: _vm.maximized
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c(
                    "q-toolbar-title",
                    [
                      _c("q-icon", { attrs: { name: "fa fa-slideshare" } }),
                      _vm._v(" " + _vm._s(_vm.titleLabel) + "\n              "),
                      this.sessionInformation.approvals &&
                      this.sessionInformation.approvals.length &&
                      !_vm.loading
                        ? _c(
                            "div",
                            {
                              staticClass: "label outline",
                              class: {
                                blue:
                                  _vm.status == "RESUBMITTED" ||
                                  _vm.status == "SUBMITTED",
                                yellow: _vm.status == "HELD",
                                green:
                                  _vm.status == "APPROVED" ||
                                  _vm.status == "PROCESSED",
                                red: _vm.status == "REJECTED"
                              },
                              staticStyle: {
                                display: "inline-block",
                                "margin-left": "10px",
                                "border-radius": "30px"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.status) +
                                  "\n              "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.status == "REJECTED" && _vm.activeApproval().NOTES
                        ? _c(
                            "div",
                            { staticStyle: { display: "inline-block" } },
                            [
                              _c(
                                "q-icon",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: {
                                    name: "fa fa-question-circle",
                                    outlined: "",
                                    color: "negative",
                                    size: "45px"
                                  }
                                },
                                [
                                  _c(
                                    "q-tooltip",
                                    {
                                      attrs: {
                                        anchor: "center right",
                                        self: "center left",
                                        offset: [10, 10]
                                      }
                                    },
                                    [
                                      _c(
                                        "h6",
                                        {
                                          staticStyle: {
                                            "font-size": "16px",
                                            "font-weight": "bold",
                                            "text-transform": "uppercase",
                                            "border-bottom": "1px solid #888",
                                            "padding-bottom": "4px",
                                            "margin-bottom": "4px"
                                          }
                                        },
                                        [_vm._v("Rejection Reason:")]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticStyle: { "font-size": "20px" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.activeApproval().NOTES)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  this.sessionInformation.approvals &&
                  this.sessionInformation.approvals.length > 0
                    ? _c(
                        "q-btn-dropdown",
                        {
                          staticClass: "approval-history",
                          attrs: { icon: "access time" }
                        },
                        _vm._l(this.sessionInformation.approvals, function(
                          approval,
                          i
                        ) {
                          return _c(
                            "q-list",
                            { key: i },
                            [
                              _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ]
                                },
                                [
                                  _c("q-item-side", {
                                    attrs: {
                                      icon: _vm.approvalDetail(approval, true)
                                    }
                                  }),
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _vm._v(
                                            "\n                              " +
                                              _vm._s(
                                                _vm.approvalDetail(approval)
                                              ) +
                                              "\n                          "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "q-item-tile",
                                        {
                                          attrs: {
                                            sublabel: "",
                                            title: _vm
                                              .moment(approval.DATE_CREATED)
                                              .format("llll")
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                              " +
                                              _vm._s(
                                                _vm
                                                  .moment(approval.DATE_CREATED)
                                                  .calendar()
                                              ) +
                                              "\n                          "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      )
                    : _vm._e(),
                  !_vm.loading &&
                  !_vm.submitting &&
                  (_vm.canEdit || _vm.$p(["ADMIN"])) &&
                  _vm.mode != "add"
                    ? _c(
                        "q-btn-dropdown",
                        { attrs: { icon: "more vert" } },
                        [
                          _c(
                            "q-list",
                            { attrs: { link: "" } },
                            [
                              _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ],
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.onRemoveClass()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _c("q-icon", {
                                            attrs: {
                                              name: "fa fa-trash",
                                              color: "red"
                                            }
                                          }),
                                          _vm._v(" Delete Class")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("q-icon", {
                    staticClass: "gt-sm",
                    attrs: { size: "20px", name: "filter_none" },
                    nativeOn: {
                      click: function($event) {
                        _vm.toggleMaximized()
                      }
                    }
                  }),
                  _c("q-icon", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.submitting,
                        expression: "!submitting"
                      }
                    ],
                    attrs: { name: "clear" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.onCancel($event)
                      }
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "sl-row sl-abs" }, [
                _c(
                  "div",
                  {
                    staticClass: "collapser",
                    on: {
                      click: function($event) {
                        _vm.toggleSidebar()
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa",
                      class: _vm.sidebarVisible
                        ? "fa-angle-left"
                        : "fa-angle-right"
                    })
                  ]
                ),
                _vm.sidebarVisible
                  ? _c(
                      "div",
                      { class: _vm.leftPaneClasses },
                      [
                        _vm.canEdit
                          ? _c(
                              "q-btn",
                              {
                                attrs: { icon: "add", id: "addSession" },
                                on: {
                                  click: function($event) {
                                    _vm.updateAddNewSession()
                                  }
                                }
                              },
                              [
                                _c(
                                  "q-tooltip",
                                  {
                                    attrs: {
                                      anchor: "center right",
                                      self: "center left",
                                      offset: [10, 10]
                                    }
                                  },
                                  [_vm._v("Add a Session")]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("q-select", {
                          attrs: {
                            id: "sessionDropdown",
                            "float-label": _vm.sessionsLabel(),
                            options: _vm.sessionInformation.sessions
                          },
                          model: {
                            value: _vm.sessionInformation.selected,
                            callback: function($$v) {
                              _vm.$set(_vm.sessionInformation, "selected", $$v)
                            },
                            expression: "sessionInformation.selected"
                          }
                        }),
                        _c(
                          "q-list",
                          { attrs: { highlight: "" } },
                          [
                            _c(
                              "q-item",
                              {
                                class: {
                                  active: _vm.selectedTab === "details"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.updateSelectedTab("details")
                                  }
                                }
                              },
                              [
                                _c("q-item-main", {
                                  attrs: { label: "Details" }
                                }),
                                _c(
                                  "q-item-side",
                                  { attrs: { left: "" } },
                                  [
                                    _vm.invalidDetails
                                      ? _c("q-icon", {
                                          staticStyle: {
                                            "margin-right": "6px"
                                          },
                                          attrs: {
                                            name: "fa fa-flag",
                                            color: "red"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "q-item",
                              {
                                class: {
                                  active: _vm.selectedTab === "students"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.updateSelectedTab("students")
                                  }
                                }
                              },
                              [
                                _c("q-item-main", {
                                  attrs: { label: "Students" }
                                }),
                                _c(
                                  "q-item-side",
                                  { attrs: { left: "" } },
                                  [
                                    _vm.$anyStudentError()
                                      ? _c("q-icon", {
                                          staticStyle: {
                                            "margin-right": "6px"
                                          },
                                          attrs: {
                                            name: "fa fa-flag",
                                            color: "red"
                                          }
                                        })
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      { staticClass: "label round small " },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentSessionOrFirst(
                                              "Students"
                                            ).students.length
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            this.mode !== "add"
                              ? _c(
                                  "q-item",
                                  {
                                    class: {
                                      active: _vm.selectedTab === "documents"
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        _vm.updateSelectedTab("documents")
                                      }
                                    }
                                  },
                                  [
                                    _c("q-item-main", {
                                      attrs: { label: "Documents" }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.sessionInformation.certificates.length > 0
                              ? _c(
                                  "q-item",
                                  {
                                    class: {
                                      active: _vm.selectedTab === "certificates"
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        _vm.updateSelectedTab("certificates")
                                      }
                                    }
                                  },
                                  [
                                    _c("q-item-main", {
                                      attrs: { label: "Certificates" }
                                    }),
                                    _c("q-item-side", { attrs: { left: "" } }, [
                                      _c(
                                        "div",
                                        { staticClass: "label round small " },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.sessionInformation
                                                .certificates.length
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.sessionInformation.orders.length > 0
                              ? _c(
                                  "q-item",
                                  {
                                    class: {
                                      active: _vm.selectedTab === "payments"
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        _vm.updateSelectedTab("payments")
                                      }
                                    }
                                  },
                                  [
                                    _c("q-item-main", {
                                      attrs: { label: "Payments" }
                                    }),
                                    _c("q-item-side", { attrs: { left: "" } }, [
                                      _c(
                                        "div",
                                        { staticClass: "label round small " },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.sessionInformation.orders
                                                .length
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.mode != "add"
                              ? _c(
                                  "q-item",
                                  { attrs: { id: "class-code" } },
                                  [
                                    _c(
                                      "q-field",
                                      { attrs: { icon: "memory" } },
                                      [
                                        _c("h6", [_vm._v("Class Code")]),
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bolder" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.sessionInformation.code
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    class: _vm.rightPaneClasses,
                    staticStyle: { "padding-bottom": "60px" },
                    attrs: { id: "class-modal-right" }
                  },
                  [
                    _vm.selectedTab === "details"
                      ? _c(
                          "div",
                          [
                            _c("class-session-details", {
                              attrs: {
                                validation: _vm.validation,
                                addressError: _vm.addressError
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedTab === "students"
                      ? _c(
                          "div",
                          { attrs: { id: "studentContainer" } },
                          [
                            _c("class-student-details", {
                              attrs: { validation: _vm.validation }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedTab === "documents"
                      ? _c(
                          "div",
                          [
                            _c("class-documents", {
                              attrs: { count: _vm.documentCount },
                              on: {
                                "update:count": function($event) {
                                  _vm.documentCount = $event
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.selectedTab === "certificates"
                      ? _c("div", [_c("class-certificates")], 1)
                      : _vm._e(),
                    _vm.selectedTab === "payments"
                      ? _c("div", [_c("class-payments")], 1)
                      : _vm._e()
                  ]
                )
              ]),
              _c(
                "q-toolbar",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  (_vm.$p(["ADMIN"]) && _vm.status) ||
                  (_vm.$p(["MANAGER"]) && _vm.status && _vm.mode == "approve")
                    ? _c(
                        "div",
                        [
                          _vm.status != "APPROVED" &&
                          _vm.status != "PROCESSED" &&
                          _vm.$p(["ADMIN", "MANAGER"], "or")
                            ? _c("q-btn", {
                                attrs: {
                                  label: "Approve",
                                  icon: "done",
                                  color: "positive"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.submitForApprovalMethod({
                                      id: _vm.sessionInformation.classId,
                                      status: 2
                                    })
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" \n              "),
                          _vm.status != "REJECTED" &&
                          _vm.$p(["ADMIN", "MANAGER"], "or")
                            ? _c(
                                "q-btn-dropdown",
                                {
                                  staticStyle: { "margin-right": "6px" },
                                  attrs: {
                                    label: "Reject",
                                    outline: "",
                                    icon: "clear",
                                    color: "negative"
                                  }
                                },
                                [
                                  _c(
                                    "q-list",
                                    { attrs: { id: "rejectionOverlay" } },
                                    [
                                      _c("q-item", [
                                        _c(
                                          "div",
                                          { staticClass: "reject-notes" },
                                          [
                                            _c("q-input", {
                                              attrs: {
                                                "stack-label":
                                                  "Rejection Notes*",
                                                type: "textarea",
                                                value: _vm.rejectionNotes
                                              },
                                              on: {
                                                input: function(val) {
                                                  return _vm.updateRejectionNotes(
                                                    val
                                                  )
                                                }
                                              }
                                            }),
                                            _c("q-btn", {
                                              attrs: {
                                                label: "Reject",
                                                icon: "clear",
                                                color: "negative"
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  _vm.submitForApprovalMethod({
                                                    id:
                                                      _vm.sessionInformation
                                                        .classId,
                                                    status: 3
                                                  })
                                                }
                                              }
                                            }),
                                            _c("q-btn", {
                                              directives: [
                                                {
                                                  name: "close-overlay",
                                                  rawName: "v-close-overlay"
                                                }
                                              ],
                                              attrs: {
                                                label: "Cancel",
                                                outline: ""
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  ((_vm.showApproveAction &&
                    !_vm.activeApproval() &&
                    _vm.canEdit) ||
                    _vm.status == "REJECTED") &&
                  _vm.$p(["ADMIN", "MANAGER", "AFFILIATE", "INSTRUCTOR"], "or")
                    ? _c("q-btn", {
                        attrs: {
                          color: "primary",
                          outline: "",
                          label: _vm.submitForApprovalLabel,
                          loading: _vm.submitting,
                          disable: _vm.submitting
                        },
                        nativeOn: {
                          click: function($event) {
                            _vm.submitForApprovalMethod({
                              id: _vm.sessionInformation.classId,
                              status: _vm.status == "REJECTED" ? 5 : 1
                            })
                          }
                        }
                      })
                    : _vm._e(),
                  ((_vm.showApproveAction &&
                    !_vm.activeApproval() &&
                    _vm.canEdit) ||
                    _vm.status == "REJECTED") &&
                  _vm.$p(["ADMIN", "MANAGER", "AFFILIATE", "INSTRUCTOR"], "or")
                    ? _c("q-btn", {
                        staticClass: "q-ml-sm",
                        attrs: {
                          color: "purple",
                          outline: "",
                          label: "Upload Roster",
                          loading: _vm.submitting,
                          disable: _vm.submitting
                        },
                        nativeOn: {
                          click: function($event) {
                            return _vm.uploadRoster($event)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.status == "APPROVED"
                    ? _c("q-btn", {
                        attrs: {
                          color: "primary",
                          outline: "",
                          label: "Process Class",
                          disabled: _vm.issuing
                        },
                        on: {
                          click: function($event) {
                            _vm.checkoutClassMethod()
                          }
                        }
                      })
                    : _vm._e(),
                  _c("q-toolbar-title"),
                  _vm.validationErrorWhenSaving
                    ? _c("span", { staticClass: "text-red" }, [
                        _c("i", { staticClass: "fa fa-warning" }),
                        _vm._v(" Please correct all errors!  \n          ")
                      ])
                    : _vm._e(),
                  _vm.selectedTab === "documents" &&
                  (!_vm.status ||
                    _vm.status === "Not Submitted" ||
                    _vm.status == "REJECTED")
                    ? _c(
                        "div",
                        { staticClass: "q-px-sm" },
                        [
                          _c("q-btn", {
                            staticClass: "q-px-md",
                            attrs: { label: "Upload", color: "green" },
                            on: {
                              click: function($event) {
                                _vm.openUploadModal()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("q-btn", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.loading && _vm.canEdit,
                        expression: "!loading && canEdit"
                      }
                    ],
                    staticStyle: { "margin-left": "5px" },
                    attrs: {
                      color: "green",
                      label: _vm.saveLabel,
                      loading: _vm.saving,
                      disable:
                        (_vm.loading ||
                          !_vm._.isEmpty(
                            _vm.sessionInformation.rereportStudents
                          )) &&
                        !_vm.$p(["ADMIN"])
                    },
                    on: { click: _vm.save }
                  }),
                  _vm.sessionInformation.classStatus == 5 &&
                  !_vm._.isEmpty(_vm.sessionInformation.rereportStudents)
                    ? _c("q-btn", {
                        staticStyle: { "margin-left": "5px" },
                        attrs: {
                          color: "purple",
                          label: "Rereport Students",
                          disabled: _vm.submitting || _vm.saving
                        },
                        on: {
                          click: function($event) {
                            _vm.rereportMethod()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" \n          "),
                  _c("q-btn", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.submitting && !_vm.issuing,
                        expression: "!submitting && !issuing"
                      }
                    ],
                    attrs: { outline: "", color: "faded", label: "Cancel" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.onCancel($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "q-inner-loading",
            { attrs: { visible: _vm.loading } },
            [
              _c("q-spinner-puff", { attrs: { color: "primary", size: "70" } }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.submitting,
                      expression: "submitting"
                    }
                  ]
                },
                [_vm._v("Submitting")]
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.issuing,
                      expression: "issuing"
                    }
                  ]
                },
                [_vm._v("Issuing Certificates")]
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.rereporting,
                      expression: "rereporting"
                    }
                  ]
                },
                [_vm._v("Reprocessing Certificates")]
              )
            ],
            1
          ),
          _c("confirm-modal", {
            attrs: {
              isOpen: _vm.showConfirmModal,
              closeModal: _vm.closeConfirmModal,
              onOk: _vm.onConfirm,
              title: "Want faster processing?",
              body: "Upload your roster now!",
              confirmText: "Upload Roster",
              cancelText: "No thanks"
            }
          }),
          _vm.addressWarning
            ? _c("address-approval-warning", {
                attrs: { result: _vm.addressWarning.result },
                on: {
                  approve: function($event) {
                    _vm.answerAddressWarning(true)
                  },
                  cancel: function($event) {
                    _vm.answerAddressWarning(false)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }